module.exports = __webpack_public_path__ + "media/club_deals/how_it_works-1c3647d4.webp";